import axios from 'Services/axios';
import { isomorphicApiV2 } from 'Services/motorway/apiClient';
import type { ApiServiceFunction } from 'Services/motorway/apiClient.types';
import * as InsightsService from 'Services/motorway/services/insights/insights';
import type {
	InsightsRecentSoldData,
	InsightsRecentSoldParams,
} from 'Services/motorway/services/insights/insights.types';
import { resolveParams } from 'Services/services.helpers';
import { API_ROUTES } from 'Utilities/routes';

export const getInsightsRecentSold: ApiServiceFunction<InsightsRecentSoldParams, InsightsRecentSoldData> = async ({
	config,
	ctx,
	params,
}) =>
	isomorphicApiV2(ctx, {
		browser: async () => {
			return axios.get(`${API_ROUTES.INSIGHTS_VEHICLES_RECENT_SOLD}${resolveParams(params)}`, config);
		},
		server: async () => {
			return InsightsService.getInsightsRecentSold({
				environment: 'server',
				params,
			});
		},
	});
